import { render, staticRenderFns } from "./ImpactLevelCard.vue?vue&type=template&id=dba4e8fe&scoped=true&"
import script from "./ImpactLevelCard.vue?vue&type=script&lang=js&"
export * from "./ImpactLevelCard.vue?vue&type=script&lang=js&"
import style0 from "./ImpactLevelCard.vue?vue&type=style&index=0&id=dba4e8fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dba4e8fe",
  null
  
)

export default component.exports